export default __webpack_public_path__ + "static/media/noiseGrey.e2cc2ee7.png";